import {Component, EventEmitter, Injectable, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';

@Component({
  selector: 'search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.css'],
})

@Injectable()
export class SearchBarComponent<T extends {_id: string}> implements OnChanges, OnInit {
  @Input() private id: string = '';
  @Input() private allObjects: Array<T> = [];
  @Input() private fieldsToSearch: Array<Array<string>>;
  @Output() private filteredObjects: EventEmitter<Array<T>> = new EventEmitter();

/*  private _allObjects: Array<T>;
  get allObjects(): Array<T> {
    return this._allObjects;
  }
  @Input() set allObjects(value: Array<T>) {
    this._allObjects = value;
    const map = {};
    for (let i = 0; i < value.length; i++) {
      map[value[i]._id] = value[i];
    }
    this._allObjectsMap = map;
  }

  private _fieldsToSearch: Array<Array<string>>;
  private __fieldsToSearchMap: Dictionary<Array<T>>;
  get fieldsToSearch(): Array<Array<string>>{
    return this._fieldsToSearch;
  }
  @Input() set fieldsToSearch(value: Array<Array<string>>) {
    this._fieldsToSearch = value;
    const map = {};
    for (let i = 0; i < value.length; i++) {
      map[value[i]._id] = value[i];
    }
    this._allObjectsMap = map;
  }*/
  public searchTerm: string;

  public ngOnInit(): void {
    if (this.id != '' ) {
      const s = localStorage.getItem('searchbar-searchterm-'+this.id);
      if ( s !== undefined && s != null) {
        this.searchTerm = s;
      }
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    this.searchTermChange();
  }

  public searchTermChange(): void {
    this.filteredObjects.emit(this.filterObjects());
    if (this.id != '' && this.searchTerm !== undefined && this.searchTerm != null) {
      localStorage.setItem('searchbar-searchterm-'+this.id, this.searchTerm);
    }
  }

  private filterObjects(): Array<T> {
    if (!this.searchTerm) {
      return this.allObjects;
    }

    const result = [];
    const searchTerms: Array<string> = this.searchTerm.toLowerCase()
    .split(' ');
    for (let i = 0; i < this.allObjects.length; i++) {
      const match = searchTerms.every((term: string) => {
        return this.fieldsToSearch[i].some((field) => {
          return field.includes(term);
        });
      });
      if (match) {
        result.push(this.allObjects[i])
      }
    }
    return result;
/*    return this.allObjects.filter((object) => {
      return this.filterBySearchTerm(object);
    });*/
  }

  private filterBySearchTerm(object: T): boolean {
    if (!this.searchTerm) {
      return true;
    }
    const searchTerms: Array<string> = this.searchTerm.toLowerCase()
      .split(' ');

    return searchTerms.every((term: string) => {
      const index: number = this.allObjects.findIndex((compareObj: T) => {
        return compareObj._id === object._id;
      });
      return this.fieldsToSearch[index].some((field) => {
        return field.includes(term);
      });
    });
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/search-bar/search-bar.component.ts